module.exports = __webpack_public_path__ + "7472f4fd0d6e68953ef80b4dbb42d54d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-13.png
// module id = 2175
// module chunks = 0